var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 1.6665C5.31675 1.6665 3.54175 3.4415 3.54175 5.62484C3.54175 7.7665 5.21675 9.49984 7.40008 9.57484C7.46675 9.5665 7.53341 9.5665 7.58341 9.57484C7.60008 9.57484 7.60841 9.57484 7.62508 9.57484C7.63341 9.57484 7.63341 9.57484 7.64175 9.57484C9.77508 9.49984 11.4501 7.7665 11.4584 5.62484C11.4584 3.4415 9.68341 1.6665 7.50008 1.6665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7333 11.7919C9.4083 10.2419 5.61663 10.2419 3.27497 11.7919C2.21663 12.5002 1.6333 13.4586 1.6333 14.4836C1.6333 15.5086 2.21663 16.4586 3.26663 17.1586C4.4333 17.9419 5.96663 18.3336 7.49997 18.3336C9.0333 18.3336 10.5666 17.9419 11.7333 17.1586C12.7833 16.4502 13.3666 15.5002 13.3666 14.4669C13.3583 13.4419 12.7833 12.4919 11.7333 11.7919Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6583 6.11659C16.7916 7.73325 15.6416 9.14992 14.05 9.34159C14.0416 9.34159 14.0416 9.34159 14.0333 9.34159H14.0083C13.9583 9.34159 13.9083 9.34159 13.8666 9.35825C13.0583 9.39992 12.3166 9.14159 11.7583 8.66659C12.6166 7.89992 13.1083 6.74992 13.0083 5.49992C12.95 4.82492 12.7166 4.20825 12.3666 3.68325C12.6833 3.52492 13.05 3.42492 13.425 3.39159C15.0583 3.24992 16.5166 4.46659 16.6583 6.11659Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3251 13.8252C18.2584 14.6335 17.7418 15.3335 16.8751 15.8085C16.0418 16.2668 14.9918 16.4835 13.9501 16.4585C14.5501 15.9168 14.9001 15.2418 14.9668 14.5252C15.0501 13.4918 14.5584 12.5002 13.5751 11.7085C13.0168 11.2668 12.3668 10.9168 11.6584 10.6585C13.5001 10.1252 15.8168 10.4835 17.2418 11.6335C18.0084 12.2502 18.4001 13.0252 18.3251 13.8252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.a90a2e3b1325397e8761f79a1108cafb.svg";
export { ForwardRef as ReactComponent };